import { publicApi } from '../lib/api'

export type ProfileReactionType = 'like' | 'comment'

export type ProfileReactionRow = {
  type: ProfileReactionType
  created_at: string
  actor: {
    handle: string
    display_name: string
    avatar_url: string
  }
  post: {
    id: number
    title: string
    slug: string
  } | null
  comment: {
    id: string
    snippet: string
  } | null
  amount_pixe: number | null
}

export type ProfileReactionsResponse = {
  count: number
  page: number
  page_size: number
  next: number | null
  previous: number | null
  results: ProfileReactionRow[]
}

export async function getProfileReactions(
  handle: string,
  params?: {
    page?: number
    page_size?: number
    q?: string
    type?: 'all' | ProfileReactionType
  }
): Promise<ProfileReactionsResponse> {
  const { data } = await publicApi.get<ProfileReactionsResponse>(
    `/api/people/${encodeURIComponent(handle)}/reactions/`,
    {
      params: {
        page: params?.page ?? 1,
        page_size: params?.page_size ?? 25,
        q: params?.q?.trim() || undefined,
        type: params?.type || undefined,
      },
    }
  )
  return data
}
